module.exports = __webpack_public_path__ + "img/wchgz-bg.f7451bf7.png";